export class CedulaDigital {
    id:             number;
    rfc:            string;
    estatus:        number;
    fechaimpresion: string;
    numeroCedula:   string;
    cedulaHashCode: number;
    fechaDescarga: string;
}
